import { getApps, initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { getDatabase, type Database } from 'firebase/database'
import { getFirestore, type Firestore } from 'firebase/firestore'
import { getStorage, type FirebaseStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

export const isFirebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId,
)

export const firebaseApp: FirebaseApp | null = isFirebaseConfigured
  ? getApps()[0] ?? initializeApp(firebaseConfig)
  : null

export const auth: Auth | null = firebaseApp ? getAuth(firebaseApp) : null
export const db: Firestore | null = firebaseApp ? getFirestore(firebaseApp) : null
export const storage: FirebaseStorage | null = firebaseApp ? getStorage(firebaseApp) : null
// Presence (online-player lists) lives in Realtime Database, not Firestore —
// it's the Firebase product built for connection-state tracking (onDisconnect).
export const rtdb: Database | null = firebaseApp && firebaseConfig.databaseURL ? getDatabase(firebaseApp) : null

export async function enableAnalytics() {
  if (!firebaseApp || typeof window === 'undefined') return null

  const { getAnalytics, isSupported } = await import('firebase/analytics')
  return (await isSupported()) ? getAnalytics(firebaseApp) : null
}

export async function trackGameEvent(name: string, details: Record<string, string | number | boolean> = {}) {
  const analytics = await enableAnalytics()
  if (!analytics) return
  const { logEvent } = await import('firebase/analytics')
  logEvent(analytics, name, details)
}
